import { BUSINESS_PLAN_TYPES, IBusinessToolType } from 'constants/businessPlan';
import {
  FOR_BANK_NAVIGATION_SEQUENCE,
  FOR_BANK_NAVIGATION_SUB_SEQUENCE,
  FOR_INVESTORS_NAVIGATION_SEQUENCE,
  FOR_INVESTORS_NAVIGATION_SUB_SEQUENCE,
  ONE_PAGE_NAVIGATION_SEQUENCE,
} from 'constants/businessToolNavigation';
import { IUnitedSections } from 'constants/businessToolSections';
import { FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { IForBankSections } from 'constants/businessToolSections/forBank';
import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { IForInvestorsSections } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import {
  getActiveSection,
  getActiveSubSection,
  getBusinessPlanType,
  getSetActiveSection,
  getSetActiveSubSection,
} from 'store/useBusinessToolStore/selectors';

import { useClearInstructions } from './useClearInstructions';

const getNavigationSequenceByType = (type: IBusinessToolType) =>
  new Map([
    [BUSINESS_PLAN_TYPES.FOR_BANK, FOR_BANK_NAVIGATION_SEQUENCE],
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS, FOR_INVESTORS_NAVIGATION_SEQUENCE],
    [BUSINESS_PLAN_TYPES.ONE_PAGE, ONE_PAGE_NAVIGATION_SEQUENCE],
    [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT, undefined],
  ]).get(type);

const getNavigationSequenceBySubType = (type: IBusinessToolType, activeSection: IUnitedSections) =>
  new Map([
    [BUSINESS_PLAN_TYPES.FOR_BANK, FOR_BANK_NAVIGATION_SUB_SEQUENCE[activeSection as IForBankSections]],
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS, FOR_INVESTORS_NAVIGATION_SUB_SEQUENCE[activeSection as IForInvestorsSections]],
    [BUSINESS_PLAN_TYPES.ONE_PAGE, undefined],
    [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT, undefined],
  ]).get(type);

export const useChangeSections = () => {
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const activeSection = useBusinessToolStore(getActiveSection);
  const activeSubSection = useBusinessToolStore(getActiveSubSection);
  const setActiveSection = useBusinessToolStore(getSetActiveSection);
  const setActiveSubSection = useBusinessToolStore(getSetActiveSubSection);

  const subSections = businessPlanType === 'BANK' ? FOR_BANK_SUB_SECTIONS : FOR_INVESTORS_SUB_SECTIONS;

  const clearFocusedFieldHandler = useClearInstructions();

  const activeItem = getNavigationSequenceByType(businessPlanType)?.find(({ name }) => name === activeSection);
  const activeSubItem = getNavigationSequenceBySubType(businessPlanType, activeSection)?.find(
    ({ name }) => name === activeSubSection,
  );

  const prevSection = activeItem?.prevItem ?? activeSection;
  const nextSection = activeItem?.nextItem ?? activeSection;

  const prevSubSection = activeSubItem?.prevItem;
  const nextSubSection = activeSubItem?.nextItem;

  const setPrevSection = () => {
    setActiveSection(prevSection);
    // @ts-ignore
    Object.values(subSections[prevSection])[0] && setActiveSubSection(Object.values(subSections[prevSection])[0]);
    clearFocusedFieldHandler();
  };

  const setNextSection = () => {
    setActiveSection(nextSection);
    // @ts-ignore
    Object.values(subSections[nextSection])[0] && setActiveSubSection(Object.values(subSections[nextSection])[0]);
    clearFocusedFieldHandler();
  };

  const setPrevSubSection = () => {
    if (prevSubSection) {
      setActiveSubSection(prevSubSection);
      clearFocusedFieldHandler();
      return;
    }
    setActiveSection(prevSection);
    // @ts-ignore
    Object.values(subSections[prevSection])[0] && setActiveSubSection(Object.values(subSections[prevSection])[0]);
    clearFocusedFieldHandler();
  };

  const setNextSubSection = () => {
    if (nextSubSection) {
      setActiveSubSection(nextSubSection);
      clearFocusedFieldHandler();
      return;
    }
    setActiveSection(nextSection);
    // @ts-ignore
    Object.values(subSections[nextSection])[0] && setActiveSubSection(Object.values(subSections[nextSection])[0]);
    clearFocusedFieldHandler();
  };

  return { setPrevSection, setNextSection, setPrevSubSection, setNextSubSection };
};
